import {
  rtmpDestinationV2EntityRaw,
  RtmpDestinationV2EntityRaw
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseResponseDTO } from "@youm-front/common/domain";

export class RtmpDestinationUpdateResponseDTO extends BaseResponseDTO<RtmpDestinationUpdateResponseDTORaw> {
  private static validateFunction = JsonSchemaValidator.compile(
    RtmpDestinationUpdateResponseDTO.validationSchema()
  );

  constructor(value: RtmpDestinationUpdateResponseDTORaw) {
    super(
      JsonSchemaValidator.assert(
        RtmpDestinationUpdateResponseDTO.validateFunction,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["destination"],
      properties: {
        destination: rtmpDestinationV2EntityRaw
      },
      additionalProperties: false
    };
  }
}

interface RtmpDestinationUpdateResponseDTORaw {
  destination: RtmpDestinationV2EntityRaw;
}
